import React from "react";
import { FormattedMessage } from "react-intl";

import { SVLANG } from "@utils/constant";
import { DISCOUNT_TYPE, APPLICATION_TYPE } from "@utils/enum";

export const DISCOUNT_TYPE_RADIO_OPTIONS = [
  {
    id: DISCOUNT_TYPE.PERCENTAGE,
    name: "discount_type",
    value: DISCOUNT_TYPE.PERCENTAGE,
    inputId: `discount_type.${DISCOUNT_TYPE.PERCENTAGE}`,
    label: <FormattedMessage id="label_percent" />,
  },
  {
    id: DISCOUNT_TYPE.FIXED_AMOUNT,
    name: "discount_type",
    value: DISCOUNT_TYPE.FIXED_AMOUNT,
    inputId: `discount_type.${DISCOUNT_TYPE.FIXED_AMOUNT}`,
    label: <FormattedMessage id="label_fixed_amount" />,
  },
];

export const APPLICATION_TYPE_RADIO_OPTIONS = [
  {
    id: APPLICATION_TYPE.ENTIRE_ORDER,
    name: "application_type",
    value: APPLICATION_TYPE.ENTIRE_ORDER,
    inputId: `application_type.${APPLICATION_TYPE.ENTIRE_ORDER}`,
    label: <FormattedMessage id="label_entire_order" />,
  },
  {
    id: APPLICATION_TYPE.SINGLE_ORDER_ITEM,
    name: "application_type",
    value: APPLICATION_TYPE.SINGLE_ORDER_ITEM,
    inputId: `application_type.${APPLICATION_TYPE.SINGLE_ORDER_ITEM}`,
    label: <FormattedMessage id="label_single_item" />,
  },
];

export const COUPON_STATUSES = [
  {
    name: SVLANG.active,
    value: 1,
  },
  {
    name: SVLANG.label_inactive,
    value: 0,
  },
];
